const { render } = wp.element;
import App from './App.js';
import './css/map-styles.css';

if (document.getElementById('wtrmapdiv')) {
	render(<App />, document.getElementById('wtrmapdiv'));
}
